import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';



@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    isUserAuthorized: false;
  constructor(private route: ActivatedRoute) { }
  identityServer = "";

  ngOnInit() {
      this.identityServer = environment.identityServer.replace("{{enviroment}}", window.location.protocol + "//" + window.location.host);
      window.location.href = this.identityServer;

  }

}
